import React, { Component } from "react";
import { connect } from "react-redux";
import { DIMENSIONS } from "services/layoutManager";
import { FilterProvider } from "context/FilterContext";
import { AvatarApi } from "services/avatar";
import BloxPage from "sub_components/Layout/BloxPage";
import ComponentWrapper from "sub_components/Layout/ComponentWrapper";
import { RESOLUTIONS } from "services/config";
import { TICKET_TYPES } from "utils/TicketConstants";
import { ColoGraph } from "styled_components/Colo/ColoGraph";
import DonutChart from "sub_components/Common/DonutChart";
import { Filter } from "styled_components/Common/Filter";
//import { StatusDisplay } from 'styled_components/Common/StatusDisplay';
import { Switch } from "styled_components/Common/Switch";
import {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
} from "actions/siteTracking";
import { updatePermissions } from "actions/permissions";
import { setHomeTour } from "actions/tour";
import { updateUsers } from "actions/company";
import { MENU as COLO_MENU } from "utils/ColoConstants";
import { SITE_PAGES, SITE_MODULES } from "utils/CommonConstants";
import { Permissions } from "services/permissions";
import { CompanyProfileApi } from "services/companyProfile";
import { HorBarGraphContainer } from "styled_components/Colo/HorBarGraphContainer";
import { CardList } from "styled_components/Colo/CardList";

const Filtering = ["All", "Atlanta", "Birmingham"];

const LAYOUT_CONFIG = {
  [RESOLUTIONS.LOW]: {
    power: { x: 1, y: 24, dim: DIMENSIONS.FOUR_BY_TEN },
    component1: { x: 1, y: 35, dim: DIMENSIONS.FOUR_BY_EIGHT },
    component2: { x: 9, y: 35, dim: DIMENSIONS.SIX_BY_FOUR },
    topRight: { x: 5, y: 1, dim: DIMENSIONS.FOUR_BY_FOUR },
    topMiddle: { x: 9, y: 1, dim: DIMENSIONS.FOUR_BY_FOUR },
    topLeft: { x: 1, y: 1, dim: DIMENSIONS.FOUR_BY_FOUR },
  },
  [RESOLUTIONS.MED]: {
    power: { x: 1, y: 24, dim: DIMENSIONS.FOUR_BY_TEN },
    component1: { x: 1, y: 42, dim: DIMENSIONS.FOUR_BY_EIGHT },
    component2: { x: 9, y: 42, dim: DIMENSIONS.SIX_BY_FOUR },
    topRight: { x: 5, y: 1, dim: DIMENSIONS.FOUR_BY_FOUR },
    topMiddle: { x: 9, y: 1, dim: DIMENSIONS.FOUR_BY_FOUR },
    topLeft: { x: 1, y: 1, dim: DIMENSIONS.FOUR_BY_FOUR },
  },
  [RESOLUTIONS.HIGH]: {
    power: { x: 1, y: 24, dim: DIMENSIONS.FOUR_BY_TEN },
    component1: { x: 1, y: 60, dim: DIMENSIONS.FOUR_BY_EIGHT },
    component2: { x: 9, y: 60, dim: DIMENSIONS.SIX_BY_FOUR },
    topRight: { x: 5, y: 1, dim: DIMENSIONS.FOUR_BY_FOUR },
    topMiddle: { x: 9, y: 1, dim: DIMENSIONS.FOUR_BY_FOUR },
    topLeft: { x: 1, y: 1, dim: DIMENSIONS.FOUR_BY_FOUR },
  },
};

class OverviewPage extends Component {
  constructor(props) {
    super(props);
    this.avatarApi = new AvatarApi();
    this.companyApi = new CompanyProfileApi();
    this.state = {
      role: null,
      selected: "All",
      view: "power",
    };
  }

  setView = (view) => {
    this.setState({ view });
  };

  componentDidMount() {
    const {
      updateModule,
      updatePage,
      addPageToBreadCrumbs,
      site,
      permissions,
    } = this.props;
    updatePage(SITE_PAGES.COLO[COLO_MENU.OVERVIEW]);
    addPageToBreadCrumbs(
      SITE_PAGES.COLO[COLO_MENU.OVERVIEW],
      SITE_MODULES.COLO
    );

    if (site?.module !== SITE_MODULES.COLO || !permissions?.permissions) {
      this.getModulePages();
    }
    updateModule(SITE_MODULES.COLO);
  }

  getUsersRole = (id) => {
    const { auth_status } = this.props;
    const { role } = this.state;
    const { memberships = {} } = auth_status;
    const currentMembershipSelected = memberships.filter(
      (membership) => Number(membership.organizationId) === Number(id)
    );
    if (currentMembershipSelected[0].role !== role) {
      this.setState({ role: currentMembershipSelected[0].role });
    }
    return currentMembershipSelected[0].role;
  };

  goToPortalManagement = (active) => {
    const { navigate } = this.props;
    navigate("/portal/account/user_management", { active });
  };
  getModulePages = async () => {
    const {
      updatePermissions,
      auth_status: {
        user: { id: userId },
      },
      company_info: {
        customer: { id: orgId },
      },
    } = this.props;
    const response = await Permissions.getModulePermissions(5, userId, orgId);

    if (response && !response.data.error) {
      updatePermissions(response.data.pages);
    }
  };
  goToTicketHistory = (status, type) => {
    const { navigate } = this.props;
    navigate("/portal/support/ticket_history", { state: { status, type } });
  };

  setSelectedInformation = (selectedInformation) => {
    this.setState({ selectedInformation });
  };

  goToPage = (page) => {
    const { navigate } = this.props;
    navigate(`/portal/colocation/${page}`);
  };

  goToTicketHistory = (status, type) => {
    const { navigate } = this.props;
    navigate("/portal/support/ticket_history", { state: { status, type } });
  };
  setSelected = (selected) => {
    this.setState({ selected: selected.toLowerCase() });
  };

  render() {
    const {
      breakpoint,
      location,
      permissions: pages,
      navigate,
      company_info: {
        customer: { id },
      },
      site,
    } = this.props || {};
    const { selected, view } = this.state;

    return (
      <BloxPage
        name="page colocation"
        layout={LAYOUT_CONFIG[breakpoint]}
        breakpoint={breakpoint}
        location={location}
      >
        <div key={`topRight`} className="topRight">
          <ComponentWrapper title="Data Center" hideBorder>
            <CardList />
          </ComponentWrapper>
        </div>
        <div key={`topLeft`} className="topLeft">
          <ComponentWrapper hideBorder title="Viewing">
            {/* <StatusDisplay /> */}
            <Switch
              module={site?.module}
              setSelected={this.setView}
              selected={view}
              breakpoint={breakpoint}
            />
          </ComponentWrapper>
        </div>
        <div key={`topMiddle`} className="topMiddle">
          <ComponentWrapper hideBorder hideTitle className="center">
            <div className="buttons">
              <div className="tab selected body10">ALL</div>
              <div className="tab body10">ATL</div>
              <div className="tab body10">BHM</div>
              <div className="tab body10">CHA</div>
            </div>
            <DonutChart
              ticketType={TICKET_TYPES.SUPPORT}
              showTitle={this.showTitleTicketCount}
              goToTicketHistory={this.goToTicketHistory}
              id="account"
              breakpoint={breakpoint}
              navigate={navigate}
              pages={pages}
            />
            <div
              className="button body10"
              onClick={() => navigate("/portal/support")}
            >
              OPEN A TICKET
            </div>
          </ComponentWrapper>
        </div>

        <div key={`component1`} className="component1">
          <ComponentWrapper title="" hideBorder>
            <FilterProvider>
              <Filter
                module="colo"
                selected={selected}
                options={Filtering}
                callback={this.setSelected}
                filterHeading="Data Center"
              />
            </FilterProvider>
            <ColoGraph breakpoint={breakpoint} module={module} orgId={id} />
          </ComponentWrapper>
        </div>
        <div key={`component2`} className="component2">
          <ComponentWrapper hideBorder title="Average vs Commited Power (kw)">
            <HorBarGraphContainer />
          </ComponentWrapper>
        </div>
      </BloxPage>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth_status: state.auth_status,
    company_info: state.company_info,
    site: state.site_tracking,
    permissions: state.permissions,
  };
}

export default connect(mapStateToProps, {
  updateModule,
  updatePage,
  addPageToBreadCrumbs,
  updateUsers,
  updatePermissions,
  setHomeTour,
})(OverviewPage);
